import { createFileRoute } from "@tanstack/react-router";
import { LabsResearchIndex } from "~/components/labs/LabsExperience";
import { loadAllEngineeringPosts } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/labs/research/")({
  loader: () => loadAllEngineeringPosts(),
  head: () => ({
    meta: seo({
      title: "Research | C1 Labs",
      description: "Field studies, advisories, and write-ups on identity security for the age of autonomous agents.",
      url: "/labs/research",
    }),
    links: seoLinks({ url: "/labs/research" }),
  }),
  component: ResearchIndex,
});

function ResearchIndex() {
  return <LabsResearchIndex posts={Route.useLoaderData()} />;
}
